export function isSystemCountryDefinition(definition) {
    if (!definition || typeof definition !== 'object') return false;
    const systemKey = String(definition.system_key || '').trim().toLowerCase();
    return systemKey === 'country';
}

export function isEditableUserDefinition(definition) {
    if (!definition || typeof definition !== 'object') return false;
    if (isSystemCountryDefinition(definition)) return false;
    const sourceKind = String(definition.source_kind || '').trim().toLowerCase();
    return (!sourceKind || sourceKind === 'user') && definition.editable !== false;
}
